// import * as moment from "moment";

// const SESSION_DURATION_SEC = 180;

function getStorageKey(stickerId) {
  return `web-notify_${stickerId}`;
}

export function canSendNotification(stickerId) {
  if (localStorage) {
    const lastNotificationDate = localStorage.getItem(getStorageKey(stickerId));
    if (lastNotificationDate != null) { return false; }
    else { return true; }
    // const dateString = JSON.parse(lastNotificationDate);
    // const now = moment.utc();
    // const diff = now.diff(moment.utc(dateString, 'YYYY-MM-DDTHH:mm:ss'));
    // const d = moment.duration(diff);
    // return d.asSeconds() >= SESSION_DURATION_SEC;
  }

  return true;
}

export function notificationIsSent(stickerId) {
  localStorage && localStorage.setItem(getStorageKey(stickerId), JSON.stringify(new Date()));
}

import {truncateString} from "../../../../uq-ui/helpers/truncateString";

const MAX_BIG_CARD_LENGTH = 20;
const MAX_SMALL_CARD_LENGTH = 9;

export function formatAuthorName(name, options = { isBig: false }) {
  const { isBig } = options;
  const hasName = name != null && typeof name === 'string' && name.length > 0 && name !== '';
  if (hasName) {
    if (isBig) {
      if (name.length > MAX_BIG_CARD_LENGTH) {
        const firstName = name.split(' ')[0];
        if (firstName.length > 16) {
          return truncateString(name, { max: MAX_BIG_CARD_LENGTH });
        } else {
          return firstName;
        }
      }
    } else {
      if (name.length > MAX_SMALL_CARD_LENGTH) {
        const firstName = name.split(' ')[0];
        if (firstName.length > MAX_SMALL_CARD_LENGTH) {
          return truncateString(name, { max: MAX_SMALL_CARD_LENGTH });
        } else {
          return firstName;
        }
      }
    }
  }
  return name;
}

